// Function to override Siblings event and add missed product siblings
function fetchAllSiblings(page = 1, siblings = {}) {
    return fetch(`/collections/all?view=siblings&page=${page}`)
        .then(response => response.json())
        .then(products => {
            console.log(`Fetched ${products.length} products from page ${page}`);

            // Stop loop if no products in current page
            if (!products || products.length === 0) {
                console.log(`Stopping at page ${page} — no more products.`);
                return siblings;
            }

            // Collect siblings data
            products.forEach(p => {
                if (!siblings[p.family]) siblings[p.family] = [];
                siblings[p.family].push(p);
            });

            // Continue with next page
            return fetchAllSiblings(page + 1, siblings);
        });
}

// Function wrapper to handle the event and remove listener
function overrideSiblings() {

    const siblingsUpdated = sessionStorage.getItem('siblingsUpdated');

    if (siblingsUpdated) {
        console.log('Siblings already in sessionStorage — skipping override.');
        window.removeEventListener('siblings:allLoaded', overrideSiblings);
        return;
    }
    console.log("Default siblings loaded — fetching complete dataset...");

    fetchAllSiblings().then(allSiblings => {
        allSiblings = _n.filter(allSiblings, set => set.length > 1);
        sessionStorage.setItem(`siblings_${window.siblingStorage}`, JSON.stringify(allSiblings));
        window.siblings = allSiblings;

        console.log("Overridden siblings data with full product list:", window.siblings);
        sessionStorage.setItem("siblingsUpdated", true);

        // Trigger event for other scripts
        _n.trigger(window, 'siblings:loaded', false, true);
        _n.trigger(window, 'siblings:allLoaded', false, true);
    });

    //Detach event listener after first execution
    window.removeEventListener('siblings:allLoaded', overrideSiblings);
    
}

//Register listener and detach after first run
window.addEventListener('siblings:allLoaded', overrideSiblings);



document.addEventListener("DOMContentLoaded", function () {
  const targetDiv = document.querySelector(".select_amount_btn"); 
  const htmlTag = document.documentElement; // <html> tag

  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "data-focus-visible"
      ) {
        if (htmlTag.hasAttribute("data-focus-visible")) {
          targetDiv.style.display = "none"; // hide once
          observer.disconnect(); 
        }
      }
    });
  });

  observer.observe(htmlTag, { attributes: true });
});
